<template>
  <div class="d-flex w-full h-full flex-column align-center justify-center">
    <v-progress-circular
      :size="size"
      :width="width"
      indeterminate
      color="primary"
    />
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: {
      type: [Number, String],
      default: 125
    },
    width: {
      type: [Number, String],
      default: 4
    }
  }
};
</script>
